// extracted by mini-css-extract-plugin
export default {"wrapper":"docs-layout_wrapper__TTW2I","container":"docs-layout_container__-rZMs"};